// extracted by mini-css-extract-plugin
export var addButton = "_fn-0";
export var border = "_fn-8";
export var check = "_fn-h";
export var danger = "_fn-6";
export var dropdownContainer = "_fn-1";
export var editModalBody = "_fn-j";
export var footerContainer = "_fn-i";
export var fullWidth = "_fn-a";
export var hide = "_fn-9";
export var icon = "_fn-3";
export var input = "_fn-7";
export var inputFlex = "_fn-b";
export var inputWrapper = "_fn-c";
export var manualFocus = "_fn-5";
export var optionButton = "_fn-4";
export var pillWrapper = "_fn-e";
export var pointer = "_fn-2";
export var showOverflow = "_fn-f";
export var tagsFlex = "_fn-d";
export var xButton = "_fn-g";